export default __webpack_public_path__ + "static/media/g18603.b64bb531.svg";